import AboutUsCompo from 'csdd_components/AboutUsCompo';
import Footer from 'csdd_components/Footer';
import HomeNavBar from 'csdd_components/HomeNavBar';
import Newsletter from 'csdd_components/Newsletter';
import PartnersCompo from 'csdd_components/PartnersCompo';
import TopNavBar from 'csdd_components/TopNavBar';

const AboutUs = () => {
  return (
    <>
      <TopNavBar />
      <HomeNavBar />
      <AboutUsCompo />
      <PartnersCompo />
      <Newsletter />
      <Footer />
    </>
  );
};
export default AboutUs;
